import { render, staticRenderFns } from "./AppSwitcherIcon.vue?vue&type=template&id=b380c89e&scoped=true&"
import script from "./AppSwitcherIcon.vue?vue&type=script&lang=ts&"
export * from "./AppSwitcherIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitcherIcon.vue?vue&type=style&index=0&id=b380c89e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b380c89e",
  null
  
)

export default component.exports